/** Shared landing imagery (main + designers pages). */
export const LANDING_LIB_IMAGES = [
  '/landing/burger_smokey_obsidian.png',
  '/landing/youmind_hero2.jpg',
  '/landing/kartinai_poster_hero.png',
  '/landing/pardus_14.jpg',
  '/landing/anime_style_ea1d.jpg',
  '/landing/youmind_feat1.jpg',
  '/landing/bag_infographic_ebfa.jpg',
  '/landing/vector_edit_72e1.jpg',
  '/landing/pardus_24.jpg',
  '/landing/poster_case113.jpg',
  '/landing/c343d521_32.jpg',
  '/landing/pardus_33.jpg',
  '/landing/youmind_ex2.jpg',
  '/landing/youmind_ex3.jpg',
  '/landing/youmind_ex4.jpg',
] as const

export const LANDING_EXAMPLE_COUNT = 6

export const LANDING_HERO_VIDEO = '/landing/burger_11.mp4'
export const LANDING_HERO_VIDEO_POSTER = '/landing/burger_11.jpg'

/** Hero mockup on /designers — product, moodboard, infographic (not burger/marketplace). */
export const DESIGNERS_HERO_PREVIEW = {
  large: [2, 1],
  small: [6, 7, 8],
} as const

/** Hero mockup on /marketplace — product card assets (paths, not lib indices). */
export const MARKETPLACE_HERO_PREVIEW = {
  large: ['/landing/3.png', '/landing/5.png'] as const,
  small: ['/landing/6.png', '/landing/7.mp4', '/landing/9.mp4'] as const,
}
